import "core-js/modules/es.error.cause.js";
function _checkPrivateRedeclaration(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
export { _checkPrivateRedeclaration as default };